import { logEvent } from "../analytics";
import { CELL_STATE } from "../cell";
import {
  explodeCanvasEl,
  levelIndicatorEl,
  menuEl,
  pickLevelBgEl,
  pickLevelEl,
  pickLevelItemsEl,
  wonAnimationEl,
  wonBannerEl,
} from "../elements";
import { Exploder } from "../explode";
import { POSITIONS } from "../info";
import { stack } from "../nav";
import { playMp3 } from "../sound";
import store from "../store";
import { autoTranslateElements } from "../translate";

let i_ = 0;
export const SHAPE = {
  FULL: i_++,
  TRIANGLE: i_++,
  TRIANGLE_INV: i_++,
  HEX: i_++,
  HEX_2: i_++,
  SQUARE: i_++,
  RECTANGLE_H: i_++,
  RECTANGLE_V: i_++,
  RANDOM: i_++,
  GRID: i_++,
  GRID_2: i_++,
  SMALL_GRID: i_++,
  GRID_VAR: i_++,
  GRID_VAR_2: i_++,
  GRID_W_PAIRS: i_++,
  DENSE_GRID: i_++,
  CIRCLE: i_++,
  RECTANGLE: i_++,
  V_LINES: i_++,
  V_LINES_2: i_++,
  V_LINES_VAR: i_++,
  H_LINES: i_++,
  H_LINES_2: i_++,
  H_LINES_VAR: i_++,
  H_LINE: i_++,
  V_LINE: i_++,
  PAIRS_ORIENT: i_++,
  PAIRS_ORIENT_2: i_++,
  PAIRS: i_++,
  SPARSE_PAIRS: i_++,
  DENSE_PAIRS: i_++,
  PAIRS_VAR: i_++,
  PAIRS_VAR_2: i_++,
  PAIRS_VAR_3: i_++,
  GROUP_OF_4: i_++,
  CROSS: i_++,
  SOLIDS_H: i_++,
  SOLIDS_H_L: i_++,
  SOLIDS_V: i_++,
  ZIGZAG: i_++,
  DIAG: i_++,
  DIAG_2: i_++,
  DOT_LINE: i_++,
  DOT_LINE_2: i_++,
  POINT: i_++,
  LINE_V: i_++,
  LINE_H: i_++,
  LINE_ANGLE: i_++,
  LINE_ANGLE_INV: i_++,
  LINES_ANGLE: i_++,
  LINES_ANGLE_INV: i_++,
  HEX_3: i_++,
  HEX_OUTLINE: i_++,
  HEX_OUTLINE_DOTTED: i_++,
  BLOCK_L: i_++,
  BLOCK_R: i_++,
};

// export const INVERSE_SHAPE = Object.keys(SHAPE).reduce((acc, key) => {
//     acc[SHAPE[key]] = key;
//     return acc;
//   }, {});

export function placement(state, shapes = SHAPE.RANDOM, shapeVariables = 20) {
  if (typeof shapes === "number") {
    shapes = [shapes];
    shapeVariables = [shapeVariables];
  }
  return { shapes: zip(shapes, shapeVariables), state };
}

export function info(coords, text, step = 0, position = POSITIONS.BOTTOM) {
  return { coords, text, position, step };
}

const zip = (a, b) => a.map((k, i) => [k, b[i]]);

export function field(shapes = SHAPE.FULL, shapeVariables = null) {
  if (typeof shapes === "number") {
    shapes = [shapes];
    shapeVariables = [shapeVariables];
  }
  return zip(shapes, shapeVariables);
}

export function helperCfg({
  placement = null,
  maxSteps = null,
  showPointer = false,
  loop = true,
} = {}) {
  return { placement, maxSteps, showPointer, loop };
}

export const lvlCfg = ({
  fieldGeometries = field(SHAPE.FULL),
  fieldSize = 15, // 10, 11, 14, 15, 18, 22
  placements = [
    placement(CELL_STATE.BLOCKED),
    // placement(CELL_STATE.NON_BLOCKABLE, SHAPE.RANDOM, 4),
    // placement(CELL_STATE.DROP, SHAPE.RANDOM, 4),
    // placement(CELL_STATE.CENTER, SHAPE.RANDOM, 4),
    // placement(CELL_STATE.SHUFFLE, SHAPE.RANDOM, 4),
    // placement(CELL_STATE.CATCH, SHAPE.RANDOM, 4),
    // placement(CELL_STATE.RANDOM, SHAPE.RANDOM, 4),
  ],
  catPlacement = placement(null, SHAPE.POINT, [0, 0]),
  helper = helperCfg(),
  info = null,
  timeLimit = 60 * 2,
  stepsLimit = null,
  trapCat = false,
  tutorial = false,
} = {}) => ({
  fieldGeometries,
  fieldSize,
  placements,
  catPlacement,
  helper,
  info,
  timeLimit,
  stepsLimit,
  trapCat,
  tutorial,
});

// export function setLevelCb(e) {
//   e.stopImmediatePropagation();
//   //   processPickLevelMenu();
//   pickLevelEl.style.display = "initial";
//   pickLevelBgEl.style.display = "initial";
//   logEvent("open_levels_menu");
//   setScreenName("levels_menu");
//   return false;
// }

// export function setAutoLevel() {
//   menuAutoLevelBtnEl.innerHTML = `${translate("Auto-Increment Levels")}: ${
//     store.disableAutoLevels ? translate("Off") : translate("On")
//   }`;
// }

// export function processPickLevelMenu(highscores = false) {
//   pickLevelItemsEl.innerHTML = "";
//   LEVELS.forEach((_, i) => {
//     const el = document.createElement("div");
//     el.setAttribute("class", "text-sec p2 ripple");
//     el.innerHTML = `${translate("Level")} ${i + 1}`;
//     el.style.fontSize = "5vmin";
//     el.style.display = "inline-block";
//     if (highscores) {
//       el.style.color = store.themes[3];
//       el.style.textDecoration = "none";
//       el.style.fontWeight = "regular";
//       addTouchEvent(el, getOpenLeaderboard(i));
//     } else if (i == store.levelIdx) {
//       el.style.color = store.themes[6];
//       el.style.textDecoration = "none";
//       el.style.fontWeight = "bold";
//     } else if (i < store.maxLevelIdx + 1) {
//       el.style.color = store.themes[3];
//       el.style.textDecoration = "none";
//       el.style.fontWeight = "regular";
//       addTouchEvent(el, (e) => selectLevel(e, i));
//     } else if (false) {
//       //   const rgb = getRgb(store.themes[3]);
//       //   el.style.color = `rgba(${rgb.r},${rgb.g},${rgb.b},0.5)`;
//       //   el.style.textDecoration = "line-through";
//       //   el.innerHTML =
//       //     el.innerHTML +
//       //     "<span style='text-decoration:none;display:inline-block'> 🔒</span>";
//       //   addTouchEvent(el, openSubscribe);
//     } else {
//       const rgb = getRgb(store.themes[3]);
//       el.style.color = `rgba(${rgb.r},${rgb.g},${rgb.b},0.5)`;
//       el.style.fontWeight = "regular";
//       el.style.textDecoration = "line-through";
//     }
//     pickLevelItemsEl.appendChild(el);
//     pickLevelItemsEl.appendChild(document.createElement("br"));
//   });
// }

export function switchAutoLevelCb(e) {
  e.stopImmediatePropagation();
  store.set("disableAutoLevels", !store.disableAutoLevels);
  //   setAutoLevel();
  logEvent("set_auto_level");
}

// export function selectLevel(e, lvl) {
//   e.stopImmediatePropagation();
//   store.set("levelIdx", lvl);
//   setLevel(false);
//   logEvent("select_level");
//   processPickLevelMenu();
// }

export function closePickLevel(e) {
  e && e.stopImmediatePropagation();
  pickLevelEl.style.display = "none";
  pickLevelBgEl.style.display = "none";
  pickLevelItemsEl.innerHTML = "";
  e && logEvent("close_levels_menu");
  stack.push(menuEl.style.display == "initial" ? "menu" : "game");
}

export function setLevelIndicators() {
  let levelString;
  if (
    store.screenName == "game" ||
    (store.screenName == "menu" && store.screenNamePrev == "game")
  ) {
    levelString = store.levelIdx + 1;
  } else if (
    store.screenName == "game_classic" ||
    (store.screenName == "menu" && store.screenNamePrev == "game_classic")
  ) {
    levelString = ["&nbsp&nbsp&nbspEasy", "Medium", "Hard"][
      store.classicLevelIdx
    ];
  } else if (store.screenName == "map") {
    levelString = store.maxLevelIdx + 1;
  } else {
    // log.debug(
    //   `Skipping setting level indicators for screen '${store.screenName}'`
    // );
    return;
  }
  levelIndicatorEl.innerHTML = levelString;
  autoTranslateElements(levelIndicatorEl);
}

export function launchWinAnim(short = false) {
  playMp3("success");
  return new Promise((resolve, reject) => {
    wonBannerEl.style.display = "initial";
    if (short) setTimeout(hideWonBannerEl, 2700, resolve);
    else setTimeout(winAnim, 1700, resolve, reject);
  });
}

function winAnim(resolve, reject) {
  try {
    wonAnimationEl.style.display = "initial";
    explodeCanvasEl.style.display = "initial";
    setTimeout(playMp3, 500, "meow");
    setTimeout(explodeAnim, 1000, resolve);
  } catch (e) {
    reject(e);
  }
}

const wonExploder = new Exploder();

async function explodeAnim(resolve) {
  await wonExploder.explode(
    (store.innerWidth / 2) * 0.7,
    (store.innerHeight / 2) * 0.7
  );
  await wonExploder.explode(
    (store.innerWidth / 2) * 1.3,
    (store.innerHeight / 2) * 1.3
  );
  await wonExploder.explode(
    (store.innerWidth / 2) * 0.7,
    (store.innerHeight / 2) * 1.3
  );
  // await explode(200, 200);
  wonAnimationEl.style.display = "none";
  explodeCanvasEl.style.display = "none";
  wonBannerEl.style.display = "none";
  resolve();
}

function hideWonBannerEl(resolve) {
  wonBannerEl.style.display = "none";
  resolve();
}

export function positionObject(cb, fieldSize, shape, shapeVariable) {
  return cb(getGeometryCb(fieldSize, shape, shapeVariable));
}

export function getGeometryCb(fieldSize, shape, shapeVariable) {
  const halfFieldSizeFloor = Math.floor(fieldSize / 2);
  /* eslint-disable no-unused-vars */
  switch (shape) {
    case SHAPE.FULL:
      return () => true;
    case SHAPE.TRIANGLE:
      return (i, j) =>
        i >= 2 &&
        j >= Math.floor(i / 2) + 1 &&
        j < fieldSize - Math.ceil(i / 2) - 1;
    case SHAPE.TRIANGLE_INV:
      return (i, j) =>
        i >= 2 &&
        j >=
          (fieldSize % 2
            ? Math.ceil((fieldSize - i) / 2)
            : Math.floor((fieldSize - i) / 2)) &&
        j <
          fieldSize -
            (fieldSize % 2
              ? Math.floor((fieldSize - i) / 2)
              : Math.ceil((fieldSize - i) / 2)) -
            1;
    case SHAPE.HEX:
      return (i, j) => {
        if (i > halfFieldSizeFloor) {
          const halfIFloor = Math.floor(i / 2);
          const halfICeil = Math.ceil(i / 2);
          return j >= halfIFloor - 1 && j < fieldSize - halfICeil + 1;
        } else {
          const halfIFloor = Math.floor(halfFieldSizeFloor - i / 2);
          const halfICeil = Math.ceil(halfFieldSizeFloor - i / 2);
          return j >= halfIFloor - 1 && j < fieldSize - halfICeil + 1;
        }
      };
    case SHAPE.HEX_2:
      return (i, j) =>
        getGeometryCb(fieldSize, SHAPE.HEX_3, [0, 0, halfFieldSizeFloor - 2])(
          i,
          j
        );
    case SHAPE.SQUARE:
      return (i, j) =>
        i >= 2 + shapeVariable &&
        i < fieldSize - 2 - shapeVariable &&
        j >= 2 + shapeVariable &&
        j < fieldSize - 2 - shapeVariable;
    case SHAPE.RECTANGLE_H:
      return (i, j) =>
        i >= 2 + shapeVariable[0] - shapeVariable[1] &&
        i < fieldSize - 2 - shapeVariable[0] - shapeVariable[1] &&
        j >= 2 &&
        j < fieldSize - 2;
    case SHAPE.RECTANGLE_V:
      return (i, j) =>
        i >= 2 &&
        i < fieldSize - 2 &&
        j >= 2 + shapeVariable[0] - shapeVariable[1] &&
        j < fieldSize - 2 - shapeVariable[0] - shapeVariable[1];
    case SHAPE.POINT: {
      return (i, j) =>
        j == halfFieldSizeFloor + shapeVariable[0] &&
        i == halfFieldSizeFloor + shapeVariable[1];
    }
    case SHAPE.LINE_H:
      return (i, j) => i == halfFieldSizeFloor + shapeVariable;
    case SHAPE.LINE_V:
      return (i, j) => j == halfFieldSizeFloor + shapeVariable;
    case SHAPE.LINE_ANGLE:
      return (i, j) => j == Math.floor(i / 2) + shapeVariable;
    case SHAPE.LINE_ANGLE_INV:
      return (i, j) => j == Math.floor((fieldSize - i - 1) / 2) + shapeVariable;
    case SHAPE.LINES_ANGLE:
      return (i, j) => j % 2 == Math.floor(i / 2) % 2;
    case SHAPE.LINES_ANGLE_INV:
      return (i, j) => j % 2 == Math.floor((fieldSize - i) / 2) % 2;
    case SHAPE.V_LINES:
      return (i, j) => j % 2 == 0;
    case SHAPE.V_LINES_2:
      return (i, j) => j % 2;
    case SHAPE.H_LINES:
      return (i, j) => i % 2 == 0;
    case SHAPE.H_LINES_2:
      return (i, j) => i % 2;
    case SHAPE.GRID:
      return (i, j) => i % 2 == shapeVariable && j % 2 == 0;
    case SHAPE.GRID_2:
      return (i, j) => i % 2 && j % 2;
    case SHAPE.DENSE_PAIRS:
      return (i, j) => (i + j + shapeVariable) % 3 == 0;
    case SHAPE.PAIRS:
      return (i, j) => (i + j) % 4 == shapeVariable;
    case SHAPE.SPARSE_PAIRS:
      return (i, j) => (i + j + shapeVariable) % 5 == 0;
    case SHAPE.GROUP_OF_4:
      return (i, j) => (i * (j + shapeVariable)) % 3;
    case SHAPE.CROSS:
      return (i, j) => (i * j) % (7 + shapeVariable) == 0;
    case SHAPE.SMALL_GRID:
      return (i, j) => (i * j * (i + 1) * (j + 1)) % 3;
    case SHAPE.PAIRS_VAR:
      return (i, j) => (i * j * (i + 3)) % 4;
    case SHAPE.SOLIDS_H:
      return (i, j) => (i * j * (i + 3)) % 5;
    case SHAPE.SOLIDS_V:
      return (i, j) => (i * j * (j + 3)) % 5;
    case SHAPE.CIRCLE:
      return circle(4 + shapeVariable, fieldSize);
    case SHAPE.PAIRS_ORIENT:
      return (i, j) => (i + ((j + 1) % 2)) % 3 == 0;
    case SHAPE.PAIRS_ORIENT_2:
      return (i, j) => (i + (j % 2)) % 3 == 0;
    case SHAPE.PAIRS_VAR_2:
      return (i, j) => (i + (j % 2)) % (4 + shapeVariable) == 0;
    case SHAPE.H_LINES_VAR:
      return (i, j) => (i + (j % 2) * (j % 3)) % 2 == 0;
    case SHAPE.ZIGZAG:
      return (i, j) => (i + (j % 2) + (i % 3 == 0 ? 1 : 0)) % 2 == 0;
    case SHAPE.SOLIDS_H_L:
      return (i, j) => (i + (i % 3 == 0 ? 1 : 0)) % 2 == 0;
    case SHAPE.V_LINES_VAR:
      return (i, j) => (j + (i % 3) + (j % 2 == 0 ? 1 : 0)) % 2 == 0;
    case SHAPE.DIAG:
      return (i, j) => i == j + shapeVariable;
    case SHAPE.DIAG_2:
      return (i, j) => i == fieldSize - j - 1 + shapeVariable;
    case SHAPE.GRID_VAR:
      return (i, j) => i % 2 == j % 4;
    case SHAPE.GRID_VAR_2:
      return (i, j) => i % 2 == j % 6;
    case SHAPE.GRID_W_PAIRS:
      return (i, j) => i % 3 == j % 4;
    case SHAPE.DENSE_GRID:
      return (i, j) => i % 2 == j % 3;
    case SHAPE.DOT_LINE:
      return (i, j) => j == shapeVariable[1] && (i + shapeVariable[0]) % 2 == 0;
    case SHAPE.DOT_LINE_2:
      return (i, j) => i == shapeVariable[0] && (j + shapeVariable[1]) % 2 == 0;
    case SHAPE.H_LINE:
      return (i, j) => i == halfFieldSizeFloor + shapeVariable;
    case SHAPE.V_LINE:
      return (i, j) => j == halfFieldSizeFloor + shapeVariable;
    case SHAPE.PAIRS_VAR_3:
      return (i, j) => i % 3 == j % 3;
    case SHAPE.HEX_3:
      return (i, j) => {
        const i_ = Math.abs(i - shapeVariable[0] - halfFieldSizeFloor);
        const ceilHalfI = Math.ceil(i_ / 2);
        const floorHalfI = Math.floor(i_ / 2);
        const flip = (halfFieldSizeFloor + shapeVariable[0]) % 2;
        return (
          i_ < shapeVariable[2] + 1 &&
          j - shapeVariable[1] - halfFieldSizeFloor <
            shapeVariable[2] + 1 - i_ + (flip ? ceilHalfI : floorHalfI) &&
          j - shapeVariable[1] - halfFieldSizeFloor >
            -(shapeVariable[2] + 1 - i_ + (flip ? floorHalfI : ceilHalfI))
        );
      };
    case SHAPE.HEX_OUTLINE: {
      const shapeVariableInner = [...shapeVariable];
      shapeVariableInner[2] = shapeVariable[2] - 1;
      const cbOuter = getGeometryCb(fieldSize, SHAPE.HEX_3, shapeVariable);
      const cbInner = getGeometryCb(fieldSize, SHAPE.HEX_3, shapeVariableInner);
      return (i, j) => cbOuter(i, j) && !cbInner(i, j);
    }
    case SHAPE.HEX_OUTLINE_DOTTED: {
      const shapeVariableInner = [...shapeVariable];
      shapeVariableInner[2] = shapeVariable[2] - 1;
      const cbOuter = getGeometryCb(fieldSize, SHAPE.HEX_3, shapeVariable);
      const cbInner = getGeometryCb(fieldSize, SHAPE.HEX_3, shapeVariableInner);
      return (i, j) =>
        cbOuter(i, j) &&
        !cbInner(i, j) &&
        ([
          halfFieldSizeFloor - shapeVariable[2],
          halfFieldSizeFloor + shapeVariable[2],
        ].includes(i)
          ? j % 2 == 0
          : i % 2 == 0);
    }
    case SHAPE.BLOCK_L:
      return (i, j) => i < shapeVariable[0] && j < shapeVariable[1];
    case SHAPE.BLOCK_R:
      return (i, j) =>
        i < shapeVariable[0] && j >= fieldSize - shapeVariable[1];
    case SHAPE.RANDOM:
      return () => Math.random() * 100 < shapeVariable;
    default:
      throw new Error(`Unknown shape ${shape}`);
  }
  /* eslint-enable no-unused-vars */
}

export function getDrawGeometryCb(fieldSize, shape, shapeVariable) {
  const halfFieldSizeFloor = Math.floor(fieldSize / 2);
  switch (shape) {
    case SHAPE.TRIANGLE:
      return (i, j) => {
        const halfIFloor = Math.floor(i / 2);
        const halfICeil = Math.ceil(i / 2);
        if (
          i >= 1 &&
          i < fieldSize - 1 &&
          j >= halfIFloor &&
          j < fieldSize - halfICeil
        ) {
          if (
            !(i == 1 && j == halfIFloor) &&
            !(i == 1 && j == fieldSize - halfICeil - 1)
          ) {
            return true;
          }
        }
        return false;
      };
    case SHAPE.TRIANGLE_INV:
      return (i, j) => {
        const halfIFloor = Math.floor((fieldSize - i) / 2);
        const halfICeil = Math.ceil((fieldSize - i) / 2);
        if (
          i >= 1 &&
          i < fieldSize - 1 &&
          j >= (fieldSize % 2 ? halfICeil : halfIFloor) - 1 &&
          j < fieldSize - (fieldSize % 2 ? halfIFloor : halfICeil)
        ) {
          if (
            !(i == fieldSize - 2 && j == 0) &&
            !(i == fieldSize - 2 && j == fieldSize - halfICeil - 1)
          ) {
            return true;
          }
        }
        return false;
      };
    case SHAPE.SQUARE:
    case SHAPE.FULL:
      return () => true;
    case SHAPE.RECTANGLE_H:
      return (i, j) => {
        const iStart = 1 + shapeVariable[0] - shapeVariable[1];
        const iEnd = fieldSize - 2 - shapeVariable[0] - shapeVariable[1];
        const jStart = 1;
        const jEnd = fieldSize - 2;
        const isLeft = !(i % 2);
        const isIEdge = i == iStart || i == iEnd;
        return (
          i >= iStart &&
          i <= iEnd &&
          j >= jStart &&
          j <= jEnd &&
          !(!isLeft && isIEdge && j == jEnd) &&
          !(isLeft && isIEdge && j == jStart)
        );
      };
    case SHAPE.RECTANGLE_V:
      return (i, j) => {
        const iStart = 1;
        const iEnd = fieldSize - 2;
        const jStart = 1 + shapeVariable[0] - shapeVariable[1];
        const jEnd = fieldSize - 2 - shapeVariable[0] - shapeVariable[1];
        const isLeft = !(i % 2);
        const isIEdge = i == iStart || i == iEnd;
        return (
          i >= iStart &&
          i <= iEnd &&
          j >= jStart &&
          j <= jEnd &&
          !(!isLeft && isIEdge && j == jEnd) &&
          !(isLeft && isIEdge && j == jStart)
        );
      };
    case SHAPE.HEX:
      return (i, j) => {
        const halfFieldSizeFloor = Math.floor(fieldSize / 2);
        if (i > halfFieldSizeFloor) {
          const halfIFloor = Math.floor(i / 2);
          const halfICeil = Math.ceil(i / 2);
          return j >= halfIFloor - 2 && j < fieldSize - halfICeil + 2;
        } else {
          const halfIFloor = Math.floor(halfFieldSizeFloor - i / 2);
          const halfICeil = Math.ceil(halfFieldSizeFloor - i / 2);
          return j >= halfIFloor - 2 && j < fieldSize - halfICeil + 2;
        }
      };
    case SHAPE.HEX_2:
      return (i, j) =>
        getGeometryCb(fieldSize, SHAPE.HEX_3, [0, 0, halfFieldSizeFloor - 1])(
          i,
          j
        );
    default:
      throw new Error(`Unknown field shape ${shape}`);
  }
}

function circle(rad, fieldSize) {
  return (i, j) => {
    const center = Math.floor(fieldSize / 2);
    const square = (i - center) ** 2 + (j - center) ** 2;
    return square > rad ** 2 && square < (rad + 1) ** 2;
  };
}

// export function getEpisodeIdx(levelIdx) {
//   return Math.floor(levelIdx / EPISODES_LENGTH);
// }

// export function getEpisodeByLevelIdx(levelIdx) {
//   const episodeIdx = getEpisodeIdx(levelIdx);
//   return getEpisode(episodeIdx);
// }
